import { slideUp } from '@/composables/slideUp.js';
import { slideDown } from '@/composables/slideDown.js';

/**
 * 요소를 슬라이드 토글하는 함수
 * @param {HTMLElement} element - 토글할 DOM 요소
 * @param {number} [duration=300] - 애니메이션 지속 시간(ms)
 * @returns {void}
 */
export function slideToggle(element, duration = 300) {
	if (window.getComputedStyle(element).display === 'none') {
		slideDown(element, duration);
	} else {
		slideUp(element, duration);
	}
}
